import React from 'react';
import Icon, { IconProps } from './Icon';

const DeliveryTruckIcon: React.FC<IconProps> = ({ size = 24, color = '#343B91', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 24 24" {...props}>
      <path
        d="M9.99976 7H7.6625C7.41791 7 7.29561 7 7.18052 7.02763C7.07849 7.05213 6.98094 7.09253 6.89147 7.14736C6.79055 7.2092 6.70408 7.29568 6.53113 7.46863L2.46838 11.5314C2.29543 11.7043 2.20896 11.7908 2.14712 11.8917C2.09229 11.9812 2.05188 12.0787 2.02739 12.1808C1.99976 12.2959 1.99976 12.4182 1.99976 12.6627V15.5C1.99976 15.9659 1.99976 16.1989 2.07588 16.3827C2.17737 16.6277 2.37205 16.8224 2.61707 16.9239C2.80084 17 3.03381 17 3.49976 17M8.49976 17H9.99976M9.99976 17V7.2C9.99976 6.0799 9.99976 5.51984 10.2177 5.09202C10.4095 4.71569 10.7155 4.40973 11.0918 4.21799C11.5196 4 12.0797 4 13.1998 4H18.7998C19.9199 4 20.4799 4 20.9077 4.21799C21.2841 4.40973 21.59 4.71569 21.7818 5.09202C21.9998 5.51984 21.9998 6.0799 21.9998 7.2V15C21.9998 16.1046 21.1043 17 19.9998 17M9.99976 17H13.9998M13.9998 17C13.9998 18.6569 15.3429 20 16.9998 20C18.6566 20 19.9998 18.6569 19.9998 17M13.9998 17C13.9998 15.3431 15.3429 14 16.9998 14C18.6566 14 19.9998 15.3431 19.9998 17M3.49976 17.5C3.49976 18.8807 4.61904 20 5.99976 20C7.38047 20 8.49976 18.8807 8.49976 17.5C8.49976 16.1193 7.38047 15 5.99976 15C4.61904 15 3.49976 16.1193 3.49976 17.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default DeliveryTruckIcon;

